import React from "react";

export default function LockInButton({ locked, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-6 py-3 rounded-full font-semibold text-sm tracking-wide
                  transition-colors duration-200 active:scale-[0.98]
                  ${
                    locked
                      ? "bg-red-500 text-zinc-50 shadow-lg ring-2 ring-red-400/40 hover:bg-red-400"
                      : "bg-emerald-400 text-zinc-950 shadow-lg ring-2 ring-emerald-400/40 hover:bg-emerald-300"
                  }`}
    >
      {locked ? "Undo" : "Lock In"}
    </button>
  );
}
